import React from 'react'
import { Box, Center } from '@mantine/core'
import * as classes from './LoadingPageLoader.module.scss'

/**
 * Renders a loading text animation. It uses CSS animations.
 * @returns {JSX.Element}
 */
export default function LoadingPageLoader () {
  return (
    <Center w='100vw' h='100vh'>
      <Box w='300px' h='50px' className={classes.loadingText}></Box>
    </Center>
  )
}
